<template>
  <div class="registration_box tj_box">
    <div class="outside_box">
      <div class="form_box" v-if="!isLoading">
        <div style="height:40px;background:rgb(80, 102, 146);"></div>
        <div class="formcontent" v-if="!isSuccess">
          <form action="">
            <div class="title">高山书院（GASA）2020级推荐表</div>
            <div class="desc">
              <p style="color:#696969;margin:0;line-height:1.5;">您正在填写高山书院（GASA）2020级推荐表，推荐表对于报名人员是否入选极其重要，请您认真填写。
              <br>我们收到信息后会尽快与您联系。</p>
              <p style="color:#000;margin:0;line-height:1.5;">如您有任何问题，可以与我们取得联系。<br>王茜：cici.wang@gwc.net 微信号：wangqcici</p>
            </div>
            <div class="borderline"></div>
            <div class="form_list">
              <div class="part firstPart">
                <div class="form_group">
                  <b class="must">您是？<span style="display:block;color:#666;font-size:14px;font-weight:300;">推荐人必须符合以下其一条件</span></b>
                  <select v-model="registerData.referee_roleid" v-validate="'required'" name="referee_roleid">
                    <option value="" selected disabled style="display:none;">请选择</option>
                    <option value="0">长城会会员</option>
                    <option value="1">高山书院校董</option>
                    <option value="2">高山书院班委</option>
                    <option value="3">高山书院学员</option>
                    <option value="4">其他</option>
                  </select>
                  <input type="text" v-if="registerData.referee_roleid == '4'" class="text" style="margin-top:10px;">
                  <p class="warnname" style="font-size:14px;margin-bottom:0;color:#f5222d;" v-show="errors.has('referee_roleid')">请填写此项</p>
                </div>
                <div class="form_group">
                  <b class="must">您的姓名</b>
                  <input type="text" v-model="registerData.referee_name" class="text" name="referee_name" v-validate="'required'">
                  <p class="warnname" style="font-size:14px;margin-bottom:0;color:#f5222d;" v-show="errors.has('referee_name')">请填写此项</p>
                </div>
                <div class="form_group">
                  <b class="must">被推荐者姓名</b>
                  <input type="text" v-model="registerData.referee_person" class="text" name="referee_person" v-validate="'required'">
                  <p class="warnname" style="font-size:14px;margin-bottom:0;color:#f5222d;" v-show="errors.has('referee_person')">请填写此项</p>
                </div>
                <div class="form_group">
                  <b class="must">推荐信<span style="display:block;color:#666;font-size:14px;font-weight:300;">您推荐他的理由</span></b>
                  <textarea v-model="registerData.referee_comment" class="text" name="referee_comment" v-validate="'required'"></textarea>
                  <p class="warnname" style="font-size:14px;margin-bottom:0;color:#f5222d;" v-show="errors.has('referee_comment')">请填写此项</p>
                </div>
              </div>
              <div class="borderline"></div>
            </div>
          </form>
          <div class="submit" >
            <input type="submit" value="提交" @click="register">
          </div>
        </div>
        <div class="submitSuccess" v-else>
          <div>提交成功</div>
        </div>
      </div>
      <div v-else class="form_box loading_box">
        <img style="width:300px;margin:0 auto;display:block;" src="@/assets/images/load2.gif" alt="">
        <p style="text-align:center;">提交中，请耐心等候......</p>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
@import "registration.page.less";
</style>
<script>
export default {
  data () {
    return {
      isSuccess: false,
      isLoading: false,
      registerData: {
        referee_roleid: '',
        referee_name: '',
        referee_person: '',
        referee_comment: '',
        timer: null
      }
    }
  },
  methods: {
    register: function () {
      let self = this
      self.$validator.validate().then(result => {
        if (result) {
          self.isLoading = true
          self.$http.post('http://127.0.0.1:8003/v2/registration/referee/add', {
            referee_roleid: self.registerData.referee_roleid,
            referee_name: self.registerData.referee_name,
            referee_person: self.registerData.referee_person,
            referee_comment: self.registerData.referee_comment
          })
            .then(function (res) {
              // console.log(res.data.id)
              var id = res.data.id
              self.isLoading = false
              self.isSuccess = true
              self.timer = setInterval((id) => {
                self.$router.push({
                  name: 'registration',
                  params: {
                    data: id
                  }
                })
                clearInterval(self.timer)
              }, 3000)
            })
            .catch(function (error) {
              console.log(error)
              self.isLoading = false
            })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/registration/tj.page.vue